var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospitalJobCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.18 14.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facility") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hospital_icon",
    "data-name": "hospital icon",
    fill: "current",
    d: "M2.17,0A2.21,2.21,0,0,0,0,2.25v9.6A2.21,2.21,0,0,0,2.17,14.1H11a2.21,2.21,0,0,0,2.17-2.25V2.25A2.21,2.21,0,0,0,11,0H2.17ZM9.62,10.32a.55.55,0,0,1-.54.56H8.5A.55.55,0,0,1,8,10.32V7.68H5.21v2.63a.55.55,0,0,1-.54.56H4.09a.55.55,0,0,1-.54-.56V3.79a.55.55,0,0,1,.54-.56h.58a.55.55,0,0,1,.54.56h0V6.16H8V3.79a.55.55,0,0,1,.54-.56h.58a.55.55,0,0,1,.54.56h0v6.53Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalJobCard);
export default __webpack_public_path__ + "static/media/hospitalJobCard.fc18ceb8.svg";
export { ForwardRef as ReactComponent };